import { render, staticRenderFns } from "./ContactSearchCategoriesFilter.vue?vue&type=template&id=354e6901&"
import script from "./ContactSearchCategoriesFilter.vue?vue&type=script&lang=js&"
export * from "./ContactSearchCategoriesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports